var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.227 2.27255L14.2574 6.56755C14.4564 6.9892 14.8405 7.28157 15.2859 7.34923L19.8282 8.0415C20.9504 8.21306 21.397 9.65319 20.5848 10.4784L17.3002 13.8201C16.9774 14.1487 16.8305 14.6211 16.9068 15.0851L17.682 19.8029C17.8729 20.97 16.6997 21.8604 15.6967 21.3083L11.6369 19.0792C11.2389 18.8606 10.7622 18.8606 10.3631 19.0792L6.30334 21.3083C5.30026 21.8604 4.1271 20.97 4.31916 19.8029L5.09316 15.0851C5.16952 14.6211 5.02259 14.1487 4.6998 13.8201L1.4152 10.4784C0.603017 9.65319 1.0496 8.21306 2.17185 8.0415L6.71406 7.34923C7.15949 7.28157 7.54475 6.9892 7.74375 6.56755L9.77305 2.27255C10.2752 1.21058 11.7248 1.21058 12.227 2.27255Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive);
export default __webpack_public_path__ + "static/media/five.dcfe30d31d21f518b9f17164aba87fdf.svg";
export { ForwardRef as ReactComponent };